/*
 * 請求管理の「プランの料金」の［プランを追加］から、契約企業一覧のプランマスターへ
 * 「追加の幕を開いて始める」と伝える、1回かぎりの合図（2026-10-08）。
 *
 * 最初は道の目印（?addPlan=1）で渡し、開いたあとで目印を外していた（router.replace）。
 * ところが目印を外すと画面が作り直され、開いたばかりの幕が消えた。手元の画面を本物の
 * クリックで操作して見つかった（スクリプトでの確かめでは、移ったあとに読み込み直しを
 * 挟んでいたので見逃していた）。
 *
 * 道は変えずに、ここで合図を1回だけ預かる。読み込み直すと合図は消える（幕は開かない）。
 */
let asked = false

/** 請求管理の側：次に契約企業一覧を開いたら、プランを追加する幕を開いてほしい。 */
export function askToAddPlan () {
  asked = true
}

/** 契約企業一覧の側：合図があったかを受け取る。受け取ったら消える（1回かぎり）。 */
export function takeAddPlanRequest () {
  const was = asked
  asked = false
  return was
}
